import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, formatApiError } from "../lib/api";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAdminAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState("processing"); // processing | denied | error

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await adminApi.post("/auth/session", {
          session_id: sessionId,
        });
        setUser(data.user);
        // نظّف #session_id من الـURL ثم انتقل للوحة
        navigate("/admin/suggestions", { replace: true });
      } catch (err) {
        const code = err?.response?.status;
        if (code === 403) {
          setStatus("denied");
          setTimeout(() => navigate("/admin?denied=1", { replace: true }), 1200);
        } else {
          setStatus("error");
          setTimeout(() => navigate("/admin", { replace: true }), 1500);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0A1128] text-white flex items-center justify-center p-4"
      dir="rtl"
      data-testid="admin-auth-callback"
    >
      <div className="text-center">
        {status === "processing" && (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#C9A96A]" />
            <p className="mt-3 text-white/70 text-sm">جارٍ إتمام تسجيل الدخول...</p>
          </>
        )}
        {status === "denied" && (
          <p className="text-red-300 text-sm font-bold">
            غير مصرح لك بالدخول.
          </p>
        )}
        {status === "error" && (
          <p className="text-red-300 text-sm">
            تعذّر إتمام تسجيل الدخول. حاول مجددًا.
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
